import { POST } from "../../../helpers/restFunction";
export const CreateChat = async (
  userId: String,
  supportId?: string,
  data?: Object
) => {
  const path = `/cad/${userId}/cad_support_comment/${supportId}`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
